import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ChatBubble from "@/components/chat/ChatBubble";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main data-testid="site-main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* Live-chat bubble — SiteLayout only wraps public marketing/legal/blog
          routes, so portal (`/portal/*`) and admin (`/admin/*`) are already
          excluded because they use their own layouts. */}
      <ChatBubble />
    </div>
  );
}
